var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRefresh = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_318_734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62 0C27.8122 0 0 27.8122 0 62C0 96.1878 27.8122 124 62 124C96.1878 124 124 96.1878 124 62C124 27.8122 96.1878 0 62 0Z",
    fill: "#40A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M62 1.29167C95.9708 1.29167 123.618 28.7577 123.969 62.6458C123.969 62.4288 124 62.217 124 62C124 27.8122 96.1878 0 62 0C27.8122 0 0 27.8122 0 62C0 62.217 0.031 62.4288 0.031 62.6458C0.382333 28.7577 28.0343 1.29167 62 1.29167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M62 122.708C28.0292 122.708 0.382333 95.2423 0.031 61.3542C0.031 61.5712 0 61.783 0 62C0 96.1878 27.8122 124 62 124C96.1878 124 124 96.1878 124 62C124 61.783 123.969 61.5712 123.969 61.3542C123.618 95.2423 95.9657 122.708 62 122.708Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 18.0833C37.7839 18.0833 18.0834 37.7838 18.0834 62C18.0834 64.0925 18.259 66.1385 18.5639 68.1483C18.5794 68.2775 19.3854 72.4883 19.9485 74.3948L40.0675 54.2758L32.2917 46.5C37.9027 35.7792 49.0834 28.4167 62 28.4167C68.1124 28.4134 74.1094 30.0808 79.3428 33.2389C84.5761 36.3969 88.8467 40.9254 91.6929 46.3347L99.1845 38.843C91.4294 26.4172 77.7274 18.0833 62 18.0833ZM105.483 56.1462C105.431 55.7845 104.625 51.3412 104.093 49.5535L83.9274 69.719L91.7084 77.5C86.0974 88.2208 74.9167 95.5833 62 95.5833C55.8877 95.5866 49.8907 93.9191 44.6573 90.7611C39.424 87.6031 35.1534 83.0746 32.3072 77.6653L24.8155 85.1622C32.5604 97.588 46.2675 105.917 62 105.917C86.2162 105.917 105.917 86.2162 105.917 62C105.906 60.0411 105.761 58.0852 105.483 56.1462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 61.9793L93.0517 31.031L92.9225 31.0207C95.2971 33.3845 97.3977 36.0086 99.1845 38.843L91.6928 46.3347C88.8467 40.9254 84.5761 36.3969 79.3427 33.2389C74.1094 30.0808 68.1124 28.4134 62 28.4167C49.0833 28.4167 37.9027 35.7792 32.2865 46.4948L40.0675 54.2758L19.9485 74.4L27.7657 82.212L32.3072 77.6705C35.154 83.0788 39.4249 87.6062 44.6582 90.7633C49.8915 93.9204 55.8881 95.5871 62 95.5833C74.9167 95.5833 86.0973 88.2208 91.7135 77.5052L83.9273 69.719L104.093 49.5535C104.625 51.3412 105.436 55.7793 105.483 56.1462C105.741 58.063 105.917 60.0108 105.917 62C105.917 86.2162 86.2162 105.917 62 105.917C53.7612 105.907 45.6966 103.545 38.7552 99.107L63.5707 123.922C97.0248 123.07 124 95.6608 124 62V61.9793Z",
    fill: "url(#paint0_linear_318_734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 0C27.8122 0 0 27.8122 0 62C0 96.1878 27.8122 124 62 124C96.1878 124 124 96.1878 124 62C124 27.8122 96.1878 0 62 0Z",
    fill: "url(#paint1_linear_318_734)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_734",
    x1: 42.284,
    y1: 41.447,
    x2: 95.7228,
    y2: 94.8858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_318_734",
    x1: 5.8125,
    y1: 35.7998,
    x2: 118.187,
    y2: 88.2002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_318_734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRefresh);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/refresh.ab6b4c609d620f4dfd3831f10dfc677a.svg";